import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addMerchantWithdrawOrder, getCurrencyList, getMerchantAccountSignList, getMerchantPayOutChannelList } from "@/api/merchantOrder";
import infoList from "@/mixins/infoList";
export default {
  name: "Transfer",
  mixins: [infoList],
  data: function data() {
    return {
      accountSignList: [],
      accountList: [],
      currencyList: [],
      currency: '',
      account: '',
      channelId: '',
      channelIdList: {},
      tradTypeId: '',
      tradTypeList: {
        0: '银行',
        1: 'upi'
      },
      tradType: '',
      transfer: {
        MerchantID: this.$store.getters['user/merchantId'],
        WithdrawAccountId: '',
        CurrencyType: 0,
        Amount: null,
        ChannelId: '',
        tradType: null,
        Remark: ''
      }
    };
  },
  methods: {
    getCurrency: function getCurrency() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getCurrencyList();
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                _this.currencyList = res.data;
                _this.currency = _this.currencyList[0];
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getMerchantAccount: function getMerchantAccount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getMerchantAccountSignList();
            case 1:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.accountSignList = res.data;
                _this2.accountSignList.forEach(function (item) {
                  _this2.accountList.push(item['title']);
                });
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    submitTransfer: function submitTransfer() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return addMerchantWithdrawOrder(_this3.transfer);
            case 1:
              res = _context3.sent;
              if (res.code == 0) {
                _this3.$message.success(res.msg);
                _this3.$router.back();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    formatAccount: function formatAccount() {
      var _this4 = this;
      this.accountSignList.forEach(function (item) {
        if (item['title'] == _this4.account) {
          console.log(item);
          _this4.transfer.WithdrawAccountId = item['merchantId'];
          console.log(_this4.transfer);
          return;
        }
      });
    },
    getChannelList: function getChannelList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return getMerchantPayOutChannelList(_this5.addContactList);
            case 1:
              res = _context4.sent;
              if (res.code == 0) {
                _this5.channelIdList = res.data;
                _this5.channelId = _this5.channelIdList[Object.keys(_this5.channelIdList)[0]];
                _this5.transfer.ChannelId = Object.keys(_this5.channelIdList)[0];
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return _this6.getCurrency();
          case 1:
            _context5.next = 2;
            return _this6.getMerchantAccount();
          case 2:
            _context5.next = 3;
            return _this6.getChannelList();
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};